import { render, staticRenderFns } from "./SubSectionHeader.vue?vue&type=template&id=29dc68e1"
import script from "./SubSectionHeader.vue?vue&type=script&lang=js"
export * from "./SubSectionHeader.vue?vue&type=script&lang=js"
import style0 from "./SubSectionHeader.vue?vue&type=style&index=0&id=29dc68e1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports